export default {"src":"/uk/_next/static/media/thumbsUpIcon.99d7bbe1.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};